var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.075 23.516C1.265 13.642 0 12.629 0 9a9 9 0 1 1 18 0c0 3.629-1.264 4.642-8.075 14.516a1.125 1.125 0 0 1-1.85 0z",
    id: "74jg33fx2a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    stroke: "#1890FF",
    strokeWidth: 2,
    fillRule: "nonzero",
    xlinkHref: "#74jg33fx2a",
    transform: "translate(1 1)",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b18dbaac4b6cd7aa3808c1f8f1da8af4.svg";
export { ForwardRef as ReactComponent };